import React from 'react';
import { Check } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { ZodiacTheme } from './zodiacThemes';
interface SubscriptionsTabProps {
  theme: ZodiacTheme;
  onNavigate: (page: string) => void;
}
export function SubscriptionsTab({
  theme,
  onNavigate
}: SubscriptionsTabProps) {
  return <div className="space-y-6" data-id="element-16017">
      <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-16018">
        Управление подпиской
      </h2>
      <Card padding="lg" className={`border-2 ${theme.border} ${theme.ring} shadow-md relative overflow-hidden`} data-id="element-16019">
        <div className={`absolute top-0 right-0 bg-gradient-to-r ${theme.gradient} text-white text-xs font-bold px-3 py-1 rounded-bl-lg`} data-id="element-16020">
          Активна
        </div>
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-8" data-id="element-16021">
          <div data-id="element-16022">
            <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-16023">
              AstroGuide Plus
            </h3>
            <p className="text-slate-600" data-id="element-16024">
              Ежемесячная подписка для глубокого погружения
            </p>
          </div>
          <div className="text-right" data-id="element-16025">
            <div className="text-3xl font-bold text-slate-900" data-id="element-16026">
              990 ₽{' '}
              <span className="text-lg font-normal text-slate-500" data-id="element-16027">/ мес</span>
            </div>
            <div className="text-sm text-slate-500 mt-1" data-id="element-16028">
              Следующее списание: 12 Ноя 2024
            </div>
          </div>
        </div>

        <div className="bg-slate-50 rounded-xl p-6 mb-8" data-id="element-16029">
          <h4 className="font-bold text-slate-900 mb-4" data-id="element-16030">Ваши преимущества:</h4>
          <ul className="space-y-3" data-id="element-16031">
            <li className="flex items-start text-sm text-slate-700" data-id="element-16032">
              <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-16033" />{' '}
              1 бесплатный отчёт каждый месяц (Доступно: 1)
            </li>
            <li className="flex items-start text-sm text-slate-700" data-id="element-16034">
              <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-16035" />{' '}
              Скидка 20% на консультации астрологов
            </li>
            <li className="flex items-start text-sm text-slate-700" data-id="element-16036">
              <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-16037" />{' '}
              Доступ к закрытым статьям блога
            </li>
            <li className="flex items-start text-sm text-slate-700" data-id="element-16038">
              <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-16039" />{' '}
              PRO Персональный календарь транзитов
            </li>
          </ul>
        </div>

        <div className="flex flex-col sm:flex-row gap-4" data-id="element-16040">
          <Button variant="primary" onClick={() => onNavigate('pricing')} data-id="element-16041">
            Сменить тариф
          </Button>
          <Button variant="outline" className="text-rose-600 hover:text-rose-700 hover:bg-rose-50 border-rose-200" data-id="element-16042">
            Отменить подписку
          </Button>
        </div>
      </Card>
    </div>;
}